/**
 * Comment Edit Toggle
 * Handles visibility toggle between view mode and edit mode
 * Following separation of concerns: no API, no dynamic HTML creation
 * Event listeners are handled by CommentEventHandler
 */

import { commentForm } from "./comment-form";

class CommentToggleHandler {
    /**
     * Show edit form and hide comment text
     */
    public showEditForm(commentId: number) {
        const commentItem = commentForm.getCommentItem(document, commentId);
        if (!commentItem) {
            return;
        }

        const commentText = commentForm.getCommentText(commentItem);
        const editForm = commentForm.getEditFormWrapper(commentItem);

        if (!(commentText instanceof HTMLElement) || !(editForm instanceof HTMLElement)) {
            return;
        }

        commentText.style.display = "none";
        editForm.style.display = "block";

        const textarea = commentForm.getEditTextarea(editForm);
        if (textarea instanceof HTMLTextAreaElement) {
            textarea.focus();
            textarea.setSelectionRange(textarea.value.length, textarea.value.length);
        }
    }

    /**
     * Hide edit form and show comment text
     */
    public hideEditForm(commentId: number) {
        const commentItem = commentForm.getCommentItem(document, commentId);
        if (!commentItem) {
            return;
        }

        const commentText = commentForm.getCommentText(commentItem);
        const editForm = commentForm.getEditFormWrapper(commentItem);

        if (!(commentText instanceof HTMLElement) || !(editForm instanceof HTMLElement)) {
            return;
        }

        commentText.style.display = "block";
        editForm.style.display = "none";

        const textarea = commentForm.getEditTextarea(editForm);
        const originalText = commentText.textContent.trim();
        if (textarea instanceof HTMLTextAreaElement) {
            textarea.value = originalText;
        }
    }
}

const commentToggleHandler = new CommentToggleHandler();

export { CommentToggleHandler, commentToggleHandler };
